import { render, staticRenderFns } from "./CollectionPrintModal.vue?vue&type=template&id=0463b6cb"
import script from "./CollectionPrintModal.vue?vue&type=script&lang=ts"
export * from "./CollectionPrintModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports